import ProjectInfo from "../models/projectInfo";
import numberHelper from "../util/numberHelper";
import unitConverter from "../util/units/unitConverter";

const covertChaingeToUnit = (chainageMeters: number, project: ProjectInfo) => {
  if (project.hasMetricUnits) {
    return unitConverter.metersToKilometers(chainageMeters);
  } else {
    return unitConverter.metersToMiles(chainageMeters);
  }
};

const covertChaingeToUnitWithDigits = (
  chainageMeters: number,
  project: ProjectInfo
) => {
  const chainageUnit = covertChaingeToUnit(chainageMeters, project);
  return numberHelper.numberTo3Digits(chainageUnit);
};

const covertChaingeToUnitSmall = (
  chainageMeters: number,
  project: ProjectInfo
) => {
  if (project.hasMetricUnits) {
    return chainageMeters;
  } else {
    return unitConverter.metersToFeet(chainageMeters);
  }
};

const covertChaingeSquareToUnitSquareSmall = (
  chainageMetersSquare: number,
  project: ProjectInfo
) => {
  if (project.hasMetricUnits) {
    return chainageMetersSquare;
  } else {
    return unitConverter.metersSquareToFeetSquare(chainageMetersSquare);
  }
};

const covertChaingeToMeters = (chainageUnit: number, project: ProjectInfo) => {
  if (project.hasMetricUnits) {
    return unitConverter.kilometersToMeters(chainageUnit);
  } else {
    return unitConverter.milesToMeters(chainageUnit);
  }
};

const getChainageUnit = (project: ProjectInfo) => {
  if (project.hasMetricUnits) {
    return "(km)";
  } else {
    return "(mi)";
  }
};

const getChainageUnitExtended = (project: ProjectInfo) => {
  if (project.hasMetricUnits) {
    return "kilometer";
  } else {
    return "mile";
  }
};

const getChainageUnitSmall = (project: ProjectInfo) => {
  if (project.hasMetricUnits) {
    return "(m)";
  } else {
    return "(ft)";
  }
};

const getChainageSquareUnitSmall = (project: ProjectInfo) => {
  if (project.hasMetricUnits) {
    return "(m^2)";
  } else {
    return "(ft^2)";
  }
};

const chainageUnitService = {
  covertChaingeToUnit,
  covertChaingeToUnitWithDigits,
  covertChaingeToUnitSmall,
  covertChaingeSquareToUnitSquareSmall,
  covertChaingeToMeters,
  getChainageUnit,
  getChainageUnitExtended,
  getChainageUnitSmall,
  getChainageSquareUnitSmall,
};

export default chainageUnitService;
